// ============================================================
// zoomPref.ts
// Per-user, per-device accessibility preference: whether the screen
// zoom & edge-pan control is enabled. Frontend-only — no backend (an
// accessibility UI aid, like the dark-mode theme pref, which also lives
// in localStorage). Backed by a tiny standalone zustand store so BOTH
// the Settings toggle and App's mount of the control react to changes
// live (a plain localStorage read wouldn't re-render on toggle).
//
// Only the ENABLED flag persists. The zoom LEVEL is deliberately NOT
// persisted — it resets to 100% each load (see ScreenZoom) so a user
// can never get stuck zoomed after a reload.
// ============================================================
import { create } from 'zustand'

const STORAGE_KEY = 'casevo_zoom_enabled'

const readEnabled = (): boolean => {
  try {
    return localStorage.getItem(STORAGE_KEY) === '1'
  } catch {
    return false
  }
}

interface ZoomPrefState {
  enabled: boolean
  setEnabled: (v: boolean) => void
}

export const useZoomPref = create<ZoomPrefState>((set) => ({
  enabled: readEnabled(),
  setEnabled: (v: boolean) => {
    try {
      localStorage.setItem(STORAGE_KEY, v ? '1' : '0')
    } catch {
      /* storage blocked (private mode) — keep the in-memory value */
    }
    set({ enabled: v })
  },
}))
